function initConfirmDestroyListener() {
    $('.confirm-destroy').on('mousedown', function (e) {
        e.preventDefault();
        if (e.button !== 1) {
            let link = $(this).data('route') ?? $(this).attr('href');
            let text = getText($(this).attr('data-text'));
            let title = $(this).attr('data-title') ?? 'Sicherheitsabfrage';
            let showCancel = $(this).attr('data-show-cancel') ?? true;

            showSweetAlert(text, link, title, showCancel);
        }
    });
}
initConfirmDestroyListener();
Livewire.on('initConfirmDestroyListener', initConfirmDestroyListener);

function showSweetAlert(text, link, title, showCancel) {
    Swal.fire({
        title: title,
        icon: 'warning',
        text: text,
        showConfirmButton: true,
        showCancelButton: showCancel,
        cancelButtonText: 'Nein',
        confirmButtonColor: '#d33',
        confirmButtonText: 'Ja',
        cancelButtonColor: '#3085d6'
    }).then((result) => {
        if (result.value) {
            window.location.href = link
        }
    });
}

function getText(text) {
    if(text === undefined) {
        return 'Den Eintrag wirklich löschen?';
    } else {
        return text;
    }
}

function initConfirmActionListener() {
    $('.confirm-action').on('mousedown', function (e) {
        e.preventDefault();
        if (e.button !== 1) {
            let link = $(this).data('route') ?? $(this).attr('href');
            let text = getText($(this).attr('data-text'));
            let title = $(this).attr('data-title') ?? 'Sicherheitsabfrage';
            let showCancel = $(this).attr('data-show-cancel') ?? true;

            showSweetAlert('Die Aktion wirklich ausführen?', link, title, showCancel);
        }
    });
}
initConfirmActionListener();
Livewire.on('initConfirmActionListener', initConfirmActionListener);

